export default __webpack_public_path__ + "static/media/rohit.525ad414.png";